import { parseISO } from 'date-fns';

export enum PriorityType {
  'High' = 'High',
  'Medium' = 'Medium',
  'Low' = 'Low'
}

export enum NewsletterType {
  'Guest' = 'Guest',
  'Internal' = 'Internal',
  'Owner' = 'Owner'
}

function AssertPortalType(type: NewsletterType) {
  if (type !== NewsletterType.Owner) {
    console.warn(`Invalid notification type received: ${type}. Expected: Owner`);
  }
}

// { [date.str]: PortalNotification['id'] }
export type ReadPortalNotification = Record<PortalNotification['id'], string>;

export class PortalNotification {
  //? ISO dates are not use on the Map written to firestore. <UTC>
  created_date_ISO: Date;

  last_modified_date_ISO: Date;

  priority_sort_order: number;

  actionLinkUrl: string = '';

  actionLinkText: string = '';

  hasLink: boolean = false;

  constructor(
    public readonly active: boolean,
    public readonly id: string,
    public readonly priority: PriorityType,
    public readonly subject: string,
    public readonly message: string,
    private readonly _action_link_url: string,
    private readonly _action_link_text: string,
    private readonly _created_date_utc: string,
    private readonly _type: NewsletterType,
    private readonly _last_modified_date_utc: string
  ) {
    AssertPortalType(this._type);

    if (this._action_link_url) {
      this.hasLink = true;
      this.actionLinkUrl = this._action_link_url;
      if (!this._action_link_text) {
        this.actionLinkText = 'More Info';
      } else {
        this.actionLinkText = this._action_link_text;
      }
    }
    this.created_date_ISO = parseISO(this._created_date_utc);
    this.last_modified_date_ISO = parseISO(this._last_modified_date_utc);
    this.priority_sort_order =
      this.priority === PriorityType.High ? 0 : this.priority === PriorityType.Medium ? 1 : 2;
  }
}

export function InstantiatePortalNotificationFromJSON(json: any) {
  return new PortalNotification(
    json.active,
    json.id,
    json.priority,
    json.subject,
    json.message,
    json.action_link_url,
    json.action_link_text,
    json.created_date_utc,
    json.type,
    json.last_modified_date_utc
  );
}
